(() => {
  const sources = (document.currentScript?.dataset.bsReviewScripts || '').split('|').filter(Boolean);
  if (!sources.length) return;
  let started = false;
  let completed = false;
  const loaded = new Set();
  let observer;
  let discovery;
  let discoveryTimer;
  const load = async () => {
    if (started || completed) return;
    started = true;
    try {
      await Promise.all(sources.map(src => {
        if (loaded.has(src)) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          script.dataset.bsReviewEnhancement = '';
          script.addEventListener('load', () => { loaded.add(src); resolve(); }, { once: true });
          script.addEventListener('error', () => { script.remove(); reject(new Error('Review enhancement unavailable')); }, { once: true });
          document.head.appendChild(script);
        });
      }));
      completed = true;
      observer?.disconnect();
      discovery?.disconnect();
      clearTimeout(discoveryTimer);
      for (const name of ['pointerdown', 'focusin', 'click']) document.removeEventListener(name, intent, true);
    } catch {
      started = false;
    }
  };
  const intent = event => {
    if (event.target instanceof Element && event.target.closest('#judgeme_product_reviews, .jdgm-modal, .jdgm-prev-badge, .jdgm-preview-badge, .jm-preview-badge, a[href*="judgeme_product_reviews"]')) void load();
  };
  for (const name of ['pointerdown', 'focusin', 'click']) document.addEventListener(name, intent, { capture: true, passive: true });
  if (!('IntersectionObserver' in window)) { void load(); return; }
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) void load();
  }, { rootMargin: '200px' });
  const observe = () => {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!widget) return false;
    observer.observe(widget);
    discovery?.disconnect();
    clearTimeout(discoveryTimer);
    return true;
  };
  if (!observe()) {
    discovery = new MutationObserver(observe);
    discovery.observe(document.body, { childList: true, subtree: true });
    discoveryTimer = setTimeout(() => discovery.disconnect(), 15000);
  }
})();
